import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Button, Tag, Tooltip, Typography, Modal, message } from 'antd'
import { CheckSquareOutlined } from '@ant-design/icons';


import CryptoJS from 'crypto-js'
import { req_page_ars_qualify, req_edit_ars_qualify } from '../../api'
import { usrRole } from '../../utils/dataUtil'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { formateDate } from '../../utils/dateUtil'

import ReservationMailModal from './reservation-mail-modal'
import ReservationSelfModal from './reservation-self-modal'
const { Text, Title } = Typography;
class RegisterReservation extends Component {

    state = {
        loading: false,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: '',
        division: '日間部',

        domnloadFile: '',
        isShowSendMailModal: false,
        isShowOnSiteModal: false,
        isShowLogModal: false,

        arrears: 0,
        cryptoUsercode: ''
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_ars_qualify(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })


        const cryptoUsercode = CryptoJS.DES.encrypt(userCode, CryptoJS.enc.Utf8.parse('Dpt__TUT'), {
            mode: CryptoJS.mode.ECB,
        }).toString()

        this.setState({ cryptoUsercode })

        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const division = result.data.Division
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination, division })
            //console.log(this.state);
            const { ArrearsTotal } = result.data[0]
            const arrears = ArrearsTotal
            this.setState({ arrears })
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_edit_item = async (type, applycase) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_edit_ars_qualify(applycase, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            const word = (type === 'CANCEL') ? '取消成功' : '簽領完成'
            message.success(word)
            this.api_page_items(this.current)
        } else {
            message.error(result.message)
        }
    }


    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '獎項名稱',
                dataIndex: 'QualifyDscription',
                width: 38,
                render: (text, item) => {
                    return (
                        <>
                            <Text type="warning"><i className="fas fa-award"></i></Text>{' '}<span> {text}</span>
                        </>
                    )
                }
            },
            {
                title: '獲獎人',
                dataIndex: 'EligibleName',
                width: 35,
                responsive: ['md'],
            },
            {
                title: '領取狀態',
                width: 40,
                responsive: ['md'],
                render: (item) => {
                    const { EligibleStatus, ReservationType, Id } = item
                    let color = this.style_switch_color_tag('EligibleStatus', EligibleStatus)
                    return (
                        <>
                            <Tag color={color} key={Id}>
                                {(EligibleStatus === 'ACCEPT') ? '未領取' : ''}
                                {(EligibleStatus === 'CASEEND' && ReservationType === 'SENDMAIL') ? '已處理' : ''}
                                {(EligibleStatus === 'CASEEND' && ReservationType === 'ONSITE') ? '已領取' : ''}
                            </Tag>
                        </>
                    )
                }
            },
            {
                title: '',
                dataIndex: '',
                width: 62,
                render: (item) => {
                    const { EligibleStatus, CaseCode, ReservationType, ReservationLocation, ReservationTimeTag, OverTodoDay, Division } = item
                    const timeTag = ReservationTimeTag.substr(4, 2) + '/' + ReservationTimeTag.substr(6, 2) + ' ' + ReservationTimeTag.substr(8, 4) + '-' + ReservationTimeTag.substr(12, 4)
                    const info = (Division === '日間部') ? '如需[取消預約]請洽學務處生活輔導組[侯雅庭小姐-(06)2535644#222]' : '如需[取消預約]請洽進修部[羅英碩先生-(06)2535647]'
                    return (CaseCode === '0000000000000000') ?
                        (
                            <>
                                <Button type="primary" size='small' onClick={() => this.handle_show_ui_reservation_onsite(item)} ><i className="far fa-calendar-plus"></i><span> 自取</span></Button> {' '}
                                <Button type="primary" size='small' onClick={() => this.handle_show_ui_reservation_sendmail(item)} ><i className="fas fa-mail-bulk"></i><span> 郵寄</span></Button>
                            </>
                        ) :
                        (
                            (EligibleStatus === 'ACCEPT') ? (
                                <>
                                    {ReservationType === 'SENDMAIL' ? (<Tooltip placement="topLeft" title="掛號郵寄"><Button size='small' disabled><i className="fas fa-shipping-fast"></i></Button></Tooltip>) : (<Tooltip placement="topLeft" title="自取"><Button size='small' disabled><i className="fas fa-user-alt"></i></Button></Tooltip>)}
                                    <Tooltip placement="topLeft" title="取得後請簽收"><Button size='small' onClick={() => this.handle_show_ui_signfor_check(item)} danger><i className="fas fa-clipboard-check"></i><span> 簽收</span></Button></Tooltip>
                                    {ReservationType === 'NONE' ? '' : (<Tooltip placement="topLeft" title={info}><Button size='small' onClick={() => this.handle_show_ui_cancel(item)} ><i className="far fa-calendar-times"></i><span> 取消</span></Button></Tooltip>)}
                                    <p />
                                    {ReservationType === 'SENDMAIL' && EligibleStatus === 'ACCEPT' ? (<><Tag color='Green'>寄送地點</Tag><Text strong>{ReservationLocation}</Text></>) : ''}
                                    <div>
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay < 0 ? (<Tag color='Red'>逾期</Tag>) : ''}
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay > 0 ? (<Tag color='Blue'>有效</Tag>) : ''}
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay === 0 ? (<Tag color='Green'>當日</Tag>) : ''}
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' ? (<Tooltip placement="topLeft" title="請準時前往領取"><Text mark>{timeTag}</Text></Tooltip>) : ''}
                                    </div>
                                    {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay === 0 ? (<Tag color='Green'>地點</Tag>) : ''}
                                    {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay === 0 && Division === '日間部' ? (<Text>中正大樓1樓(生活輔導組)</Text>) : ''}
                                    {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay === 0 && Division === '進修部' ? (<Text>育樂館1樓(進修部)</Text>) : ''}
                                </>) : (
                                <>
                                    <Button size='small' onClick={() => this.handle_show_ui_signfor_log(item)}><i className="fas fa-file-signature"></i><span> 簽領紀錄</span></Button>
                                </>
                            )
                        )
                },
            },
        ]
    }

    style_switch_color_tag(column, param) {
        switch (column) {
            case 'EligibleStatus':
                switch (param) {
                    case 'ACCEPT':
                        return 'red'
                    case 'CASEEND':
                        return 'green'
                    default:
                        return 'default';
                }
            default:
                break;
        }
    }


    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_show_ui_reservation_onsite = (item) => {
        this.setState({ isShowOnSiteModal: true, item })
    }

    handle_show_ui_reservation_sendmail = (item) => {
        this.setState({ isShowSendMailModal: true, item })
    }

    handle_show_ui_signfor_check = (item) => {
        Modal.confirm({
            title: (<>
                <span>您確定已領取 <Title level={4}><Text mark>{item.QualifyDscription}</Text></Title></span>
            </>),
            onOk: () => {
                const { userName } = this.props.user
                const data = {
                    condition: 'SIGNFOR',
                    KeyId: item.KeyId,
                    EligibleStatus: 'CASEEND',
                    CloseReservationName: userName
                    //CloseReservationTime
                }
                this.api_edit_item('CHECK', data)
            }
        })
    }

    handle_show_ui_cancel = (item) => {
        const { Division } = item
        const unit = (Division === '日間部') ? '請洽學務處生活輔導組[侯雅庭小姐]' : '請洽進修部[羅英碩先生]'
        const tel = (Division === '日間部') ? '(06)2535644#222' : '(06)2535647'
        const link = (Division === '日間部') ? 'tel:062535644#222' : 'tel:062535644#222'
        Modal.info({
            title: (<>
                <span>如需<Text mark>[取消預約]</Text>{unit}<a href={link}>{tel}</a></span>
            </>),
            footer: (
                <Button key="back" onClick={this.handleCancel}>
                    Return
                </Button>)
        })
    }

    handle_show_ui_signfor_log = (item) => {
        Modal.success({
            title: '簽領紀錄',
            icon: <CheckSquareOutlined />,
            content: (
                <>
                    <div><Tag color='Green'>簽領人員</Tag>{item.CloseReservationName}</div>
                    <div><Tag color='Green'>簽領時間</Tag>{formateDate(item.CloseReservationTime)}</div>
                </>
            ),
            okText: '確認',
        });
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, item, items, pagination, isShowSendMailModal, isShowOnSiteModal, arrears, cryptoUsercode } = this.state
        return (
            <Card>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='KeyId'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    title="預約郵寄"
                    visible={isShowSendMailModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowSendMailModal: false })
                        this.api_page_items(this.current)
                    }}
                    onCancel={() => {
                        this.setState({ isShowSendMailModal: false })
                    }}
                >
                    <ReservationMailModal qualify={item} />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="預約自取"
                    visible={isShowOnSiteModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowOnSiteModal: false })
                        this.api_page_items(this.current)
                    }}
                    onCancel={() => {
                        this.setState({ isShowOnSiteModal: false })
                    }}
                >
                    <ReservationSelfModal qualify={item} />
                </Modal>
                {arrears > 0 ? (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Tag color="red">您有計 {arrears} 項校內未處理事項會影響領獎權益</Tag><Tag color="orange"><a href={`https://ngn.tut.edu.tw/dpt/Student/show?stid=${cryptoUsercode}`}><i className="far fa-hand-point-up"></i>詳情</a></Tag></div>) : ''}
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(RegisterReservation)